<mat-toolbar color="primary">
  <span class="header-title"
    ><a href="https://ultimateshoutouts.com"
      ><img src="/assets/logo-sm.png" class="logo" alt="logo" /></a
  ></span>
  <span class="header-spacer"></span>
  @if (!hideMenu()) {
    <div>
      @if (auth.user$ | async) {
        <div>
          @if (!isMobile()) {
            <div>
              @if (!announcerMode.isActive()) {
                <button mat-button aria-label="Events" routerLink="/events">
                  <mat-icon>event</mat-icon>Events
                </button>
                <button mat-button aria-label="Account" routerLink="/user">
                  <mat-icon>manage_accounts</mat-icon>Account
                </button>
              }
              <button mat-button aria-label="Logout" (click)="logout()">
                <mat-icon>logout</mat-icon>Logout
              </button>
            </div>
          }
          @if (isMobile()) {
            <div>
              <button
                mat-icon-button
                class="header-icon"
                aria-label="Header Menu"
                [matMenuTriggerFor]="mainMenu"
              >
                <mat-icon>menu</mat-icon>
              </button>
              <mat-menu #mainMenu="matMenu">
                @if (!announcerMode.isActive()) {
                  <button mat-menu-item routerLink="/events">
                    <mat-icon>event</mat-icon>Events
                  </button>
                  <button mat-menu-item routerLink="/user">
                    <mat-icon>manage_accounts</mat-icon>Account
                  </button>
                }
                <button mat-menu-item (click)="logout()">
                  <mat-icon>logout</mat-icon>Logout
                </button>
              </mat-menu>
            </div>
          }
        </div>
      }
    </div>
  }
</mat-toolbar>
